import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-4 md:py-5 px-3 bg-brand-dark border-y border-white/5" data-id="element-67">
      <div className="max-w-xl mx-auto text-center" data-id="element-68">
        <div className="inline-flex items-center justify-center w-12 h-12 bg-white/10 rounded-full mb-2 border border-white/15" data-id="element-69">
          <ShieldCheck className="w-6 h-6 text-white" data-id="element-70" />
        </div>

        <h2 className="text-lg md:text-xl font-bold mb-2 text-white uppercase tracking-tight leading-tight" data-id="element-71">
          🛡️ Garantía 7 días — sin preguntas
        </h2>

        <div className="text-xs md:text-sm font-normal space-y-1.5 mb-3 text-white/90 leading-relaxed" data-id="element-72">
          <p data-id="element-73">
            Abrís los tomos. Los usás en el taller. Si en 7 días no es lo que
            esperabas:
          </p>
          <div className="flex flex-col items-center gap-0.5 text-white font-medium text-[11px] md:text-xs" data-id="element-74">
            <span data-id="element-75">👉 Devolución del 100%</span>
            <span data-id="element-76">👉 Sin formularios</span>
            <span data-id="element-77">👉 Sin vueltas</span>
          </div>
          <p className="text-gray-500 text-[9px] md:text-[10px] mt-2" data-id="element-78">
            Tasa de devoluciones: menos del 1%
          </p>
        </div>
      </div>
    </section>;
}